import React from "react";
import { CompanySpecificProduct } from "@/types";
import { useAuth } from "@/contexts/AuthContext";
import { useGetCompanySpecificProducts } from "@/services/Company";
import { useTranslation } from "react-i18next";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";

type keyOptions = Extract<keyof CompanySpecificProduct, string>;

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions | keyOptions[];
}

/**
 * SelectCondition component renders a Select dropdown for conditions.
 * - Uses translation for option labels.
 * @param {SelectPropsExtended} props - Props for the SelectCondition component.
 * @param {keyOptions} props.valueKey - Key to use for option values.
 * @param {keyOptions} props.labelKey - Key to use for option labels.
 */
const SelectProduct: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, ...restProps }: SelectPropsExtended) => {
  const { currentCompany } = useAuth();
  const { t } = useTranslation();
  const { data, isLoading } = useGetCompanySpecificProducts(currentCompany?.companyId as number, false, {
    enabled: !!currentCompany?.companyId,
  });

  const sourceData = data || [];
  const options = transformDataToSelectOption(
    sourceData,
    valueKey || "id",
    labelKey || "companySpecificProductName",
    t
  );

  return <Select data={options} loading={isLoading} {...restProps} />;
};

export default SelectProduct;
